import colors from "./colors";

const light = {
  name: 'light',
  //AutoComplete
  AutoComplete_ResultList_marginTop: "-2px",
  AutoComplete_ResultList_border_color: colors.TRANSPARENT,

  //Button
  Button_background_color: colors.TRANSPARENT,
  Button_background_color_disabled: colors.TRANSPARENT,
  Button_border_color: colors.WHITE,
  Button_opacity_disabled: 0.5,

  //Tab
  Tab_background_color: "rgba(255,255,255, 0.8)",
  Tab_border_color: "rgba(255,255,255, 0.8)",
  Tab_color: colors.BRAND_GREEN,
  //Tab Selected
  TabSelected_background_color: colors.BRAND_GREEN,
  TabSelected_border_color: colors.WHITE,
  TabSelected_color: colors.WHITE,

  //TextInput
  TextInput_background_color: colors.WHITE,
  TextInput_border_color: colors.BRAND_GREEN,
  TextInput_color: colors.GRAY_DARK,
  TextInput_placeholder_color: colors.GRAY_SEMI_DARK,

  //TextInput - Search
  TextInputSearch_background_color: colors.TRANSPARENT,
  TextInputSearch_border_color: colors.WHITE,
  TextInputSearch_color: colors.GRAY_DARK,
  TextInputSearch_placeholder_color: colors.GRAY_DARK,
  TextInputSearch_icon_color: colors.GRAY_SEMI,
  TextInputSearch_icon_opacity: 1,

  Placeholder_color: colors.WHITE,
  
  Logo: 'birdietime',

  // General
  BorderColor: colors.BORDER_COLOR,
  HeadingColor: colors.BRAND_GREEN,
  LinkColor: colors.BRAND_GREEN,
  ErrorColor: colors.BASIC_RED,

  //Weather
  ItemAlternateBgColor: '#fafafa',
  HighTempColor: colors.BASIC_RED,
  LowTempColor: colors.GPG_BLUE,
};

const main = {
  name: 'main',
  //AutoComplete
  AutoComplete_ResultList_marginTop: "2px",
  AutoComplete_ResultList_border_color: colors.BORDER_COLOR,

  //Button
  Button_background_color: colors.BRAND_GREEN,
  Button_background_color_disabled: colors.GRAY_SEMI,
  Button_border_color: colors.TRANSPARENT,
  Button_opacity_disabled: 1,

  //Tab
  Tab_background_color: colors.GRAY_ULTRA_LIGHT,
  Tab_border_color: colors.GRAY_SEMI,
  Tab_color: colors.GRAY_SEMI,
  //Tab Selected
  TabSelected_background_color: colors.BRAND_GREEN,
  TabSelected_border_color: colors.TRANSPARENT,
  TabSelected_color: colors.WHITE,

  //TextInput
  TextInput_background_color: colors.TRANSPARENT,
  TextInput_border_color: colors.BRAND_GREEN,
  TextInput_color: colors.GRAY_DARK,
  TextInput_placeholder_color: colors.GRAY_DARK,

  //TextInput - Search
  TextInputSearch_background_color: colors.TRANSPARENT,
  TextInputSearch_border_color: colors.GRAY_ULTRA_LIGHT,
  TextInputSearch_color: colors.GRAY_DARK,
  TextInputSearch_placeholder_color: colors.TEXT_COLOR,
  TextInputSearch_icon_color: colors.GRAY_SEMI,
  TextInputSearch_icon_opacity: 1,

  Placeholder_color: colors.GRAY_DARK,
  Logo: 'birdietime',

  MenuButtonColor: colors.BRAND_GREEN,
  NavigationHighlightColor: colors.BRAND_BLUE,

  // Button highlight color
  ButtonHighlightColor: colors.BRAND_GREEN,
  ButtonSecondaryColor: colors.BASIC_RED,
  ButtonInfoColor: colors.BRAND_BLUE,

  // card colors
  CardPriceBackground: colors.BRAND_GREEN,
  CardHightlightColor: colors.BASIC_RED,

  // General
  BorderColor: colors.BORDER_COLOR,
  HeadingColor: colors.BRAND_GREEN,
  LinkColor: colors.BRAND_GREEN,
  ErrorColor: colors.BASIC_RED,

  // Teetime
  TeetimeHeaderBackground: colors.GRAY_MEGA_LIGHT,
  TeetimeHighlightColor: colors.BRAND_GREEN,

  // Pill
  PillBackgroundColor: colors.BASIC_RED,
  PillColor: colors.WHITE,

  //Weather
  ItemAlternateBgColor: '#fafafa',
  HighTempColor: colors.BASIC_RED,
  LowTempColor: colors.GPG_BLUE,

};

const searchMinified = {};

const goplaygolf = {
  name: 'goplaygolf',
  //AutoComplete
  AutoComplete_ResultList_marginTop: 0,
  AutoComplete_ResultList_border_color: colors.BORDER_COLOR,

  //Button
  Button_background_color: colors.GPG_BLUE,
  Button_background_color_disabled: colors.GRAY_SEMI,
  Button_border_color: colors.TRANSPARENT,
  Button_opacity_disabled: 1,

  //Tab
  Tab_background_color: colors.GRAY_ULTRA_LIGHT,
  Tab_border_color: colors.GRAY_SEMI,
  Tab_color: colors.GRAY_SEMI,
  //Tab Selected
  TabSelected_background_color: colors.GPG_BLUE,
  TabSelected_border_color: colors.TRANSPARENT,
  TabSelected_color: colors.WHITE,

  //TextInput
  TextInput_background_color: colors.TRANSPARENT,
  TextInput_border_color: colors.BORDER_COLOR,
  TextInput_color: colors.GRAY_DARK,
  TextInput_placeholder_color: colors.GRAY_DARK,

  //TextInput - Search
  TextInputSearch_background_color: colors.TRANSPARENT,
  TextInputSearch_border_color: colors.GRAY_ULTRA_LIGHT,
  TextInputSearch_color: colors.GRAY_DARK,
  TextInputSearch_placeholder_color: colors.TEXT_COLOR,
  TextInputSearch_icon_color: colors.GRAY_SEMI,
  TextInputSearch_icon_opacity: 1,

  Placeholder_color: colors.GRAY_DARK,
  Logo: 'goplaygolf',

  // Navigation
  MenuButtonColor: colors.GPG_BLUE,
  NavigationHighlightColor: colors.GPG_BLUE,

  // Button highlight color
  ButtonHighlightColor: colors.GPG_BLUE,
  ButtonSecondaryColor: colors.GPG_BLUE,

  // card colors
  CardPriceBackground: colors.GPG_BLUE,
  CardHightlightColor: colors.GPG_BLUE,

  // General
  BorderColor: colors.BORDER_COLOR,
  HeadingColor: colors.GPG_BLUE,
  LinkColor: colors.GPG_BLUE,
  ErrorColor: colors.BASIC_RED,

  // TeeTime
  TeetimeHeaderBackground: colors.GRAY_MEGA_LIGHT,
  TeetimeHighlightColor: colors.GPG_BLUE,

  // Pill
  PillBackgroundColor: colors.BASIC_RED,
  PillColor: colors.WHITE,

  //Weather
  ItemAlternateBgColor: '#fafafa',
  HighTempColor: colors.BASIC_RED,
  LowTempColor: colors.GPG_BLUE,

};

export default {
  light,
  main,
  searchMinified,
  goplaygolf
};



// WEBPACK FOOTER //
// ./src/modules/common/components/ui/themes.js